// extracted by mini-css-extract-plugin
export var aniSpin = "F_d";
export var back = "F_6";
export var bg__inner = "F_bf";
export var el = "F_b";
export var front = "F_bd";
export var inner = "F_r";
export var middle = "F_bc";
export var text = "F_bg";